import type { ReactNode } from "react"
import type { UseFormReturn } from "react-hook-form"

import { Checkbox } from "@/components/ui/checkbox"
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"

type CheckboxFieldProps = {
  form: UseFormReturn<any>
  name: string
  label?: string
  description?: string
  checkboxLabel: ReactNode
}

export const CheckboxField = ({
  form,
  name,
  label,
  description,
  checkboxLabel
}: CheckboxFieldProps) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem id={`field-${name}`} data-field={name} className="space-y-2">
          {label && <FormLabel className="text-sm font-medium text-foreground">{label}</FormLabel>}
          {description ? <FormDescription>{description}</FormDescription> : null}
          <FormControl>
            <label className="flex items-start gap-2 text-sm text-foreground">
              <Checkbox
                id={`${field.name}-checkbox`}
                checked={!!field.value}
                onCheckedChange={checked => field.onChange(checked === true)}
                onBlur={field.onBlur}
                className={'mt-0.5'}
              />
              <span>{checkboxLabel}</span>
            </label>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
